export default {
  name: 'custom_checkbox_field',
  component_path: 'modules/procedures/blocks/BlockInputCheckbox'
}